import api from "../api.js";

/**
 * Checkout discount service
 *
 * Manages interactions with checkout discount codes
 * 
 * @package HOPS
 * @subpackage Checkout
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class CheckoutDiscountService {

	/**
	 * Apply a discount code to a basket.
	 *
	 * @param {Integer} BasketId
	 * @param {String} DiscountCode
	 * @param {Integer} TargetOrg
	 * @return {Promise} Resolves with API details of discounts in the basket
	 */
	static applyDiscountCode(BasketId, DiscountCode, TargetOrg) {
		return api.call({
			url: `/api/checkout/basket/${BasketId}/discounts`,
			method: "POST",
			data: {
				DiscountCode,
				TargetOrg
			}
		}).then(({data}) => data);
	}


	/**
	 * Remove discount codes from the basket.
	 * 
	 * @param {Integer} BasketId
	 * @param {Array<String>} DiscountClaims Discount claim UUIDs to remove
	 * @return {Promise} Resolves with API details of discounts in the basket
	 */
	static removeDiscountCode(BasketId, DiscountClaims) {
		return api.call({
			url: `/api/checkout/basket/${BasketId}/discounts`,
			method: "DELETE",
			data: {DiscountClaims}
		}).then(({data}) => data);
	}

}

export default CheckoutDiscountService;
